<template>
  <highcharts
    v-if="!loading"
    :options="options"
    :style="{ height: chartHeight, minHeight: '100px' }"
  ></highcharts>
  <v-progress-circular
    v-else
    :value="20"
    indeterminate
    color="#704DFA"
  ></v-progress-circular>
</template>

<script>
//
import FormatterHelper from "@/scripts/helpers/formatter.helper";
export default {
  props: {
    value: {
      type: Array,
      required: true
    },
    chartType: {
      type: String,
      default: "bar"
    },
    loading: {
      type: Boolean,
      required: true
    },
    colors: {
      type: Array,
      required: true
    }
  },
  name: "LineChart",
  data: () => ({
    options: {
      credits: {
        enabled: false
      },
      chart: {
        style: {
          fontFamily: "Nunito"
        }
      },
      title: {
        text: null
      },
      tooltip: {
        formatter: function() {
          return (
            "<b>" +
            this.point.name +
            '</b><br><span style="font-size:24px;color:' +
            this.point.color +
            '">\u25CF </span>' +
            FormatterHelper.formatMoney(this.point.y)
          );
        }
      },
      yAxis: {
        title: {
          text: null
        },
        labels: {
          formatter: function() {
            return FormatterHelper.formatMoney(this.value);
          }
        }
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 560
            },
            chartOptions: {
              legend: {
                enabled: false
              }
            }
          }
        ]
      },
      plotOptions: {
        pie: {
          states: {
            inactive: {
              opacity: 0.6
            }
          }
        },
        bar: {
          pointWidth: 10,
          borderRadius: 5
        }
      }
    }
  }),
  computed: {
    chartHeight() {
      if (this.chartType == "bar") return `${this.value.length * 50}px`;
      return "300px";
    }
  },
  watch: {
    value() {
      if (this) this.setData();
    },
    chartType() {
      if (this.options) {
        this.options.chart.type = this.chartType;
      }
    }
  },
  created() {
    if (this.options) {
      this.options.chart.type = this.chartType;
    }
  },
  methods: {
    setData() {
      if (this && this.options) {
        let valueArray = this.value.slice();
        valueArray.sort(function(a, b) {
          return b.value - a.value;
        });

        let xValues = [];
        let yValues = [];
        let i = 0;
        valueArray.forEach(p => {
          if (!p.identifier) p.identifier = "Não informado";
          xValues.push(p.identifier);
          yValues.push({
            y: p.value,
            name: p.identifier,
            color: this.colors[i % this.colors.length]
          });
          i++;
        });

        this.$set(this.options, "xAxis", {
          categories: xValues,
          title: {
            text: null
          }
        });

        this.$set(this.options, "series", [
          {
            colorByPoint: true,
            showInLegend: false,
            align: "right",
            innerSize: "45%",
            data: yValues,
            title: {
              text: null
            }
          }
        ]);
      }
    }
  }
};
</script>